/**
 * Work Order Service
 * Handles work order management API calls
 */

import axiosInstance, { apiRequest } from '../axiosInstance';
import { WORK_ORDER_ENDPOINTS, buildQueryString } from '../endpoints';

export const WorkOrderStatus = {
  OPEN: 'Open',
  IN_PROGRESS: 'InProgress',
  ON_HOLD: 'OnHold',
  COMPLETED: 'Completed',
  CANCELLED: 'Cancelled',
};

export const getWorkOrderStatusLabel = (status) => {
  const labels = {
    Open: 'Open',
    InProgress: 'In Progress',
    OnHold: 'On Hold',
    Completed: 'Completed',
    Cancelled: 'Cancelled',
  };
  return labels[status] || status;
};

const workOrderService = {
  getWorkOrders: async (params = {}) => {
    const queryString = buildQueryString(params);
    return apiRequest(() =>
      axiosInstance.get(`${WORK_ORDER_ENDPOINTS.LIST}${queryString}`)
    );
  },

  getWorkOrderById: async (id) => {
    return apiRequest(() =>
      axiosInstance.get(WORK_ORDER_ENDPOINTS.GET_BY_ID(id))
    );
  },

  createWorkOrder: async (data) => {
    return apiRequest(() =>
      axiosInstance.post(WORK_ORDER_ENDPOINTS.CREATE, data)
    );
  },

  updateWorkOrder: async (id, data) => {
    return apiRequest(() =>
      axiosInstance.put(WORK_ORDER_ENDPOINTS.UPDATE(id), data)
    );
  },

  updateWorkOrderStatus: async (id, data) => {
    return apiRequest(() =>
      axiosInstance.put(WORK_ORDER_ENDPOINTS.UPDATE_STATUS(id), data)
    );
  },

  deleteWorkOrder: async (id) => {
    return apiRequest(() =>
      axiosInstance.delete(WORK_ORDER_ENDPOINTS.DELETE(id))
    );
  },

  getWorkOrderSubmissions: async (id) => {
    return apiRequest(() =>
      axiosInstance.get(WORK_ORDER_ENDPOINTS.SUBMISSIONS(id))
    );
  },

  getCalendarWorkOrders: async (fromDate, toDate, assignedToUserId = null) => {
    const params = {
      fromDate,
      toDate,
      pageSize: 200,
    };
    if (assignedToUserId) params.assignedToUserId = assignedToUserId;
    const queryString = buildQueryString(params);
    return apiRequest(() =>
      axiosInstance.get(`${WORK_ORDER_ENDPOINTS.LIST}${queryString}`)
    );
  },
};

export default workOrderService;
